import React from 'react';
import { Label, Input, FormGroup} from 'reactstrap';

const CheckBoxControl = (props)=> {
  let {labelText, value, onChange, name, visible, disabled} = props;
  let isVisible = visible === undefined ? true : visible;
  let isDisabled = disabled === undefined ? false : disabled;
  return isVisible ? (<div className="form-group row">
    <label className="col-md-2 form-control-label"  htmlFor={name}>{labelText}</label>
    <div className="col-md-8">
      <FormGroup check>
        <Label check>
          <Input type="checkbox"
                 onChange={onChange}
                 checked={value}
                 name={name}
                 disabled={isDisabled}
          />
        </Label>
      </FormGroup>
    </div>
  </div>) : null;
};

export default CheckBoxControl;